<script setup>
import InputField from "@/Components/InputField.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";

import { router, useForm } from "@inertiajs/vue3";

const props = defineProps({
  user: Object,
  status: String,
});

const form = useForm({
  name: props.user.name,
  email: props.user.email,
});

const resendEmail = (e) => {
  router.post(
    route("verification.send"),
    {},
    {
      onStart: () => (e.target.disabled = true),
      onFinish: () => (e.target.disabled = false),
    }
  );
};
</script>

<template>
  <div class="bg-white rounded-lg shadow-sm border border-slate-200 p-6">
    <div class="mb-6">
      <h2 class="text-xl font-semibold text-slate-900">Informasi Profil</h2>
      <p class="mt-1 text-sm text-slate-600">
        Perbarui informasi profil dan alamat email akun Anda.
      </p>
    </div>

    <ErrorMessages :errors="form.errors" />

    <form @submit.prevent="form.patch(route('profile.info'))" class="space-y-6">
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
        <InputField
          label="Nama Lengkap"
          icon="id-badge"
          v-model="form.name"
          required
        />

        <InputField
          label="Alamat Email"
          icon="at"
          v-model="form.email"
          type="email"
          required
        />
      </div>

      <div
        v-if="user.email_verified_at === null"
        class="rounded-md bg-yellow-50 p-4 border border-yellow-200"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-yellow-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M8.485 3.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.19-1.458-1.515-2.625L8.485 3.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-yellow-800">
              Email belum diverifikasi
            </h3>
            <div class="mt-2 text-sm text-yellow-700">
              <p>
                Alamat email Anda belum diverifikasi.
                <button
                  @click="resendEmail"
                  class="font-medium text-yellow-800 underline hover:text-yellow-900 disabled:text-yellow-400 disabled:cursor-wait transition-colors duration-200"
                >
                  Klik di sini untuk mengirim ulang email verifikasi.
                </button>
              </p>
            </div>
          </div>
        </div>
        <SessionMessages :status="status" class="mt-3" />
      </div>

      <div class="flex items-center justify-end pt-4 border-t border-slate-200">
        <PrimaryBtn
          :disabled="form.processing"
          class="bg-maroon-600 hover:bg-maroon-700 focus:ring-maroon-500"
        >
          <span v-if="form.processing">Menyimpan...</span>
          <span v-else>Simpan Perubahan</span>
        </PrimaryBtn>
      </div>
    </form>
  </div>
</template>
